/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
var utils = require('../../../Utils.js');

const useStyles = makeStyles(theme => ({
	main: {
		'margin-left': '12px',
		'margin-right': '12px'
	},
	bio: {
		'margin-left': '48px',
		'margin-right': '48px'
	}
}));

// Very simple Patient Info snippet component, Shown on multiple pages of forms
const PatientInfoSnippet = props => {
	const classes = useStyles();
	return (
		<div className={classes.main}>
			<Typography variant="h5" color="textSecondary">
				Tidepool Loop Order Form and Treatment Plan
			</Typography>
			<div className={classes.bio}>
				<Typography variant="body2" color="textSecondary">
					{props.patient}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					Date of Birth: {utils.birthdayFix(props.dateOfBirth)}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					Email: {props.email}
				</Typography>
			</div>
		</div>
	);
};

export default PatientInfoSnippet;
